import Flex from "components/grid/Flex";
import { makeStyles } from "@material-ui/core/styles";
import { iceberg } from "components/colors/Colors";

export const labelStyle = { marginRight: 15, minWidth: 300 };
const useStyles = makeStyles((theme) => ({
    // container: {
    //     "&:nth-child(odd)": {
    //         background: iceberg,
    //     },
    // },
}));
const LabelValueContainer = ({ valueComponent, labelComponent, style = {}, skipSeparator, indent }) => {
    const classes = useStyles();
    return (
        <Flex
            item
            grow={0}
            container
            className={skipSeparator ? "" : classes.container}
            style={{marginBottom: 5, ...style }}
            // style={{ padding: skipSeparator ? 0 : '3px 3px 3px 0px', ...style }}
        >
            {labelComponent && (
                <Flex item grow={0} style={{...labelStyle, ...(skipSeparator && {minHeight: 'none'}), ...(indent && {paddingLeft: 50})}}>
                    {labelComponent}
                </Flex>
            )}
            {valueComponent}
        </Flex>
    );
};

export default LabelValueContainer;
